import React from "react";
import { Box, Button, Stack } from "@mui/material";

const PopupMenu = ({ actions, minWidth = 200 }) => {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        bgcolor: "background.paper",
        boxShadow: 3,
        minWidth,
      }}
    >
      <Stack spacing={2}>
        {actions.map((action, index) => (
          <Button
            key={index}
            variant={action.variant || "outlined"}
            color={action.color || "primary"}
            startIcon={action.icon}
            onClick={action.onClick}
            fullWidth={action.fullWidth !== false} // default true
            sx={{ textTransform: "none", whiteSpace: "nowrap" }}
          >
            {action.label}
          </Button>
        ))}
      </Stack>
    </Box>
  );
};

export default PopupMenu;
